<script lang="ts">
    import {
        addDays,
        dateOnLhsOfDisplay,
        earliestPossibleDateOnLhsOfDisplay,
    } from "./dateOptions";
    import DayCard from "./DayCard.svelte";
    import {chosenDateOptions, chosenSlotOption, washPrice} from "./stores";
    import {push} from 'svelte-spa-router'
    import {
        hasAvailableTimeSlots,
        hasPricedServices,
    } from "./state/appState";

    function clickedLeft() {
        const earlierDate = addDays($dateOnLhsOfDisplay, -3)
        if (earlierDate.getTime() < earliestPossibleDateOnLhsOfDisplay.getTime()) {
            $dateOnLhsOfDisplay = earliestPossibleDateOnLhsOfDisplay
        } else {
            $dateOnLhsOfDisplay = earlierDate
        }
    }

    function clickedRight() {
        $dateOnLhsOfDisplay = addDays($dateOnLhsOfDisplay, 3)
    }

    function onOptionChosen(event: CustomEvent) {
        const {option, productAvailability} = event.detail
        $chosenDateOptions = productAvailability
        $chosenSlotOption = option
        $washPrice = productAvailability.amount
        push("/options")
    }

</script>

{#if $hasAvailableTimeSlots && $hasPricedServices}
    <div class="wrapper px-2">
        <div class="more mt-1 text-center mx-1 py-1">
            <button class="small-screen btn btn-light border rounded" on:click={clickedLeft}><i
                    class="fas fa-angles-up mx-2"></i></button>
            <button class="large-screen btn btn-light border rounded" on:click={clickedLeft}><i
                    class="fas fa-angles-left"></i></button>
        </div>

        <DayCard dayIndex={0} on:chosenOption={onOptionChosen}/>
        <DayCard dayIndex={1} on:chosenOption={onOptionChosen}/>
        <DayCard dayIndex={2} on:chosenOption={onOptionChosen}/>

        <div class="more mt-1 text-center mx-1 py-1">
            <button class="small-screen btn btn-light border rounded" on:click={clickedRight}><i
                    class="fas fa-angles-down mx-2"></i></button>
            <button class="large-screen btn btn-light border rounded" on:click={clickedRight}><i
                    class="fas fa-angles-right"></i></button>
        </div>
    </div>
{/if}

